import React from 'react';

const BankTransferNotice = () => {
  return (
    <div className='bg-amber-50 border border-amber-200 text-amber-800 rounded-lg p-4 mb-6'>
      <p className='font-medium'>El pago con tarjeta ya no está disponible</p>
      <p className='text-sm mt-1'>Ahora aceptamos solo transferencia bancaria.</p>
    </div>
  );
};

export default BankTransferNotice;
